import React, { useEffect } from 'react';

import useStyles from 'isomorphic-style-loader/useStyles';

import { MailingDataService } from '../../private/services/mailing/mailing-data.service';
import { MailingContext } from '../../private/contexts';

import { Hero } from './components/Hero/Hero';
import { Clients } from './components/Clients/Clients';
import { Metrics } from './components/Metrics/Metrics';
import { Benefits } from './components/Benefits/Benefits';
import { SellingPoints } from './components/SellingPoints/SellingPoints';
import { SuccessCases } from './components/SuccessCases/SuccessCases';
import { Contact } from './components/Contact/Contact';
import { Achievements } from './components/Achievements/Achievements';
import { RequestConfirmationModal } from './components/RequestConfirmationModal/RequestConfirmationModal';

import s from './SlTeams.scss';
import { useContainerData } from '../../../shared/public/SlHooks/useContainerData';
import { track } from '../../../symphony';

export const SlTeams: React.FC = React.memo(() => {
	useStyles(s);
	const { teamsModal$: modal } = useContainerData(
		MailingContext,
		MailingDataService,
		['teamsModal$'],
	);

	const scrollIntoForm = (): void => {
		document
			.getElementById('sl-teams-contact')
			.scrollIntoView({ behavior: 'smooth' });

		setTimeout(() => {
			document.getElementById('firstName').focus();
		}, 700);
	};

	useEffect(() => {
		track({
			event_name: 'landing_page_impression',
			version: '2-0-0',
			experience_type_id: '5',
			experience_alias: 'SololearnTeams',
			section_type: 'MAIN HEADER PAGE',
			section_title: '',
			url_text: location.pathname,
		});
	}, []);

	return (
		<>
			<div className="sl-teams">
				<Hero onClick={scrollIntoForm} />
				<Clients />
				<Metrics />
				<Benefits onClick={scrollIntoForm} />
				<SellingPoints onClick={scrollIntoForm} />
				<SuccessCases />
				<Contact />
				<Achievements />
			</div>
			{modal && <RequestConfirmationModal />}
		</>
	);
});
